import type { ChangeWheelsView } from "@slfinrtl/ui-bff-routes"
import { defineMessages, useIntl } from "react-intl"
import { propertiesOf } from "src/common/property"
import type { SelectFieldProps } from "src/components/form/select/SelectField"

export interface ChangeSelectedWheelsForm {
	optionCode: string
}

export interface ChangeSelectedWheelsProps {
	option: SelectFieldProps
}

const messages = defineMessages({
	customWheels: {
		defaultMessage: "Custom Wheels",
		id: "equipment.wheels.customWheels",
	},
	wheels: {
		defaultMessage: "Wheels",
		id: "equipment.wheels.title",
	},
})

const formProperties = propertiesOf<ChangeSelectedWheelsForm>()

export const customWheelsOptionCode = "custom-wheels-option-code"

export const useChangeSelectedWheelsProps: (props: {
	view: ChangeWheelsView["selected"]
}) => ChangeSelectedWheelsProps = ({ view }) => {
	const { formatMessage } = useIntl()

	return {
		option: {
			label: formatMessage(messages.wheels),
			name: formProperties.optionCode._path,
			options: [
				...view.option.options.map(({ name, optionCode }) => ({
					label: name,
					value: optionCode,
				})),
				{
					label: formatMessage(messages.customWheels),
					value: customWheelsOptionCode,
				},
			],
			required: true,
		},
	}
}
